const formatPhoneNumber = (phoneNumber) => {
  const cleaned = ('' + phoneNumber).replace(/\D/g, '');

  const lastEleven = cleaned.length > 11 ? cleaned.slice(-11) : cleaned;

  const match = lastEleven.match(/^(\d{2})(\d{5})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return null;
};

const formatPhoneNumberWithCountryCode = (phone) => {
  if (!phone) return '-';
  return phone.replace(/(\d{2})(\d{2})(\d{5})(\d{4})/, '($1) $2 $3-$4');
};

export {
  formatPhoneNumber,
  formatPhoneNumberWithCountryCode
}
